import { render, staticRenderFns } from "./uploadFiles - 副本.vue?vue&type=template&id=4c9874d1&scoped=true"
import script from "./uploadFiles - 副本.vue?vue&type=script&lang=js"
export * from "./uploadFiles - 副本.vue?vue&type=script&lang=js"
import style0 from "./uploadFiles - 副本.vue?vue&type=style&index=0&id=4c9874d1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c9874d1",
  null
  
)

export default component.exports